import { SVGProps } from "react";
import { twMerge } from "tailwind-merge";

const IconPlus = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={twMerge(className)}
            width="19"
            height="19"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...rest}
        >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    );
};

export default IconPlus;
